import React from 'react'
import { observer } from 'mobx-react-lite'
import EditableSubmission from './SubmissionFormParts/EditableSubmission'
import ReviewingState from './SubmissionFormParts/ReviewingState'
import ApprovedState from './SubmissionFormParts/ApprovedState'

const EDITABLE_STATUSES = ['draft', 'requested', 'revision_requested']
const APPROVED_STATUSES = ['internally_approved', 'approved']

// role/apiBase let this same dispatcher serve both the influencer's
// zero-auth portal (defaults) and the PM's "submit on behalf" view.
export default observer(function SubmissionForm({ action, apiBase = '/api/advertiser/draft_share', role = 'influencer' }) {
  const status = action.action_draft.draft_status

  if (EDITABLE_STATUSES.includes(status)) return <EditableSubmission action={action} apiBase={apiBase} role={role} />
  if (APPROVED_STATUSES.includes(status)) return <ApprovedState action={action} role={role} />

  return <ReviewingState action={action} role={role} />
})
